import { Icon, IconButton, ICONS_ENUM } from '@sanlam-glacier/app-common/components';
import styles from './side-navigation-bar.module.scss';
import { useNavigate } from 'react-router-dom';
import { NavMenuPages } from 'modules/app/types/navigation-menu.type';
import { KeyboardEventHandler, useEffect, useState } from 'react';
import { SideNavigationItem } from '../side-navigation-item/SideNavigationItem';

type SideNavigationBarProps = {
  className?: string;
  items?: NavMenuPages;
};

export const SideNavigationBar = ({ items, className }: SideNavigationBarProps) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const onOpen = () => setIsOpen(true);
  const onClose = () => setIsOpen(false);

  useEffect(() => {
    const handleResize = () => setIsOpen(false);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const allPages = items?.mainPages.concat(items.subPages);
  const keyDown: KeyboardEventHandler<HTMLElement> = (event) => {
    if (event.key === 'Escape') onClose();
  };

  return (
    <div className={className}>
      <button className={styles.noStyleButton} onClick={onOpen}>
        <Icon icon={ICONS_ENUM.ACTION_VIEW_HEADLINE} className={styles.actionButton} />
      </button>
      {isOpen && (
        <button
          type='button'
          onKeyDown={keyDown}
          className={styles.navigationMenu}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onClose();
          }}
        >
          <div className={styles.navigationMenuContainer}>
            <div className={styles.exitButtonContainer}>
              <IconButton variant={IconButton.VARIANT.TERTIARY} onClick={onClose}>
                <Icon icon={ICONS_ENUM.CONTENT_CLEAR} />
              </IconButton>
            </div>
            {allPages
              ?.filter((entry) => entry.enabled)
              .map((entry, idx) => (
                <SideNavigationItem
                  key={entry.route}
                  item={entry}
                  onClick={() => {
                    setIsOpen(false);
                    navigate(entry.route);
                  }}
                  divider={idx !== allPages.length - 1}
                />
              ))}
          </div>
        </button>
      )}
    </div>
  );
};
